import { API_URL } from '../config/constants';
import createHistory from 'history/createBrowserHistory';

export const bHistory = createHistory();

export const setFilterTo = (data) => ({ type: 'SET_FILTER_TO', value: data });

export const setSessionData = (data) => {
    return (dispatch) => {
        dispatch({ type: 'LOGIN', value: data });
    }
}

export const logout = () => {
    return (dispatch) => {
        sessionStorage.clear();
        bHistory.go('/login');
        dispatch({ type: 'LOGOUT' });
    }
}

export const requestLanguages = (userName, passwd) => {
    return async (dispatch) => {
        try {
            const request = new Request(API_URL + "/v2/getLanguages", {
                method: 'POST',
                body: JSON.stringify({
                    username: userName,
                    password: passwd,
                }),
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            });
            const response = await fetch(request);
            if (response.status === 500) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } });
            if (response.status === 400 || response.status === 404) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non se poideron obter os datos correctamente.', code: 400 } });
            if (response.status === 403 || response.status === 401) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non ten permisos para acceder a esta información.', code: 400 } });
            const json = await response.json();
            dispatch({ type: 'REQUEST_LANGUAGES', value: json.result.data });
        } catch (err) {
            console.error(err);
            dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } })
        }
    }
}

export const requestCountries = (userName, passwd) => {
    return async (dispatch) => {
        try {
            const request = new Request(API_URL + "/v2/getCountries", {
                method: 'POST',
                body: JSON.stringify({
                    username: userName,
                    password: passwd,
                }),
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            });
            const response = await fetch(request);
            if (response.status === 500) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } });
            if (response.status === 400 || response.status === 404) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non se poideron obter os datos correctamente.', code: 400 } });
            if (response.status === 403 || response.status === 401) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non ten permisos para acceder a esta información.', code: 400 } });
            const json = await response.json();
            dispatch({ type: 'REQUEST_COUNTRIES', value: json.result.data });
        } catch (err) {
            console.error(err);
            dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } });
        }
    }
}

export const getMunicipalities = (userName, passwd) => {
    return async (dispatch) => {
        try {
            const request = new Request(API_URL + "/v2/getMunicipalities", {
                method: 'POST',
                body: JSON.stringify({
                    username: userName,
                    password: passwd,
                }),
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            });
            const response = await fetch(request);
            if (response.status === 500) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } });
            if (response.status === 400 || response.status === 404) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non se poideron obter os datos correctamente.', code: 400 } });
            if (response.status === 403 || response.status === 401) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non ten permisos para acceder a esta información.', code: 400 } });
            const json = await response.json();
            dispatch({ type: 'REQUEST_MUNICIPALITIES', value: json.result.data });
        } catch (err) {
            if (!err.code && !err.status) err.status = 500;
            dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } })
        }
    }
}

export const getOffices = (userName, passwd) => {
    return async (dispatch) => {
        try {
            let body = {
                username: userName,
                password: passwd,
            }
          
            const request = new Request(API_URL + "/v2/getOffices", {
                method: 'POST',
                body: JSON.stringify(body),
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            });
            const response = await fetch(request);
            if (response.status === 500) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } });
            if (response.status === 400 || response.status === 404) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non se poideron obter os datos correctamente.', code: 400 } });
            if (response.status === 403 || response.status === 401) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non ten permisos para acceder a esta información.', code: 400 } });
            const json = await response.json();
            dispatch({ type: 'REQUEST_OFFICES', value: json.result.data });
        } catch (err) {
            if (!err.code && !err.status) err.status = 500;
            dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } })
        }
    }
}

export const getUsers = (userName, passwd, filter) => {
    return async (dispatch) => {
        try {
            const request = new Request(API_URL + "/v2/getUsers", {
                method: 'POST',
                body: JSON.stringify({
                    username: userName,
                    password: passwd,
                    filter: {
                        office: filter.office
                    }
                }),
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            });
            const response = await fetch(request);
            if (response.status === 500) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } });
            if (response.status === 400 || response.status === 404) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non se poideron obter os datos correctamente.', code: 400 } });
            if (response.status === 403 || response.status === 401) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non ten permisos para acceder a esta información.', code: 400 } });
            const json = await response.json();
            dispatch({ type: 'REQUEST_USERS', value: json.result.data });
        } catch (err) {
            if (!err.code && !err.status) err.status = 500;
            dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } })
        }
    }
}

export const getComunities = (userName, passwd) => {
    return async (dispatch) => {
        try {
            const request = new Request(API_URL + "/v2/getComunities", {
                method: 'POST',
                body: JSON.stringify({
                    username: userName,
                    password: passwd,
                }),
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            });
            const response = await fetch(request);
            if (response.status === 500) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } });
            if (response.status === 400 || response.status === 404) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non se poideron obter os datos correctamente.', code: 400 } });
            if (response.status === 403 || response.status === 401) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non ten permisos para acceder a esta información.', code: 400 } });
            const json = await response.json();
            dispatch({ type: 'REQUEST_COMUNITIES', value: json.result.data });
        } catch (err) {
            if (!err.code && !err.status) err.status = 500;
            dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } })
        }
    }
}

export const getProvinces = (userName, passwd) => {
    return async (dispatch) => {
        try {
            const request = new Request(API_URL + "/v2/getProvinces", {
                method: 'POST',
                body: JSON.stringify({
                    username: userName,
                    password: passwd,
                }),
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            });
            const response = await fetch(request);
            if (response.status === 500) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } });
            if (response.status === 400 || response.status === 404) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non se poideron obter os datos correctamente.', code: 400 } });
            if (response.status === 403 || response.status === 401) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non ten permisos para acceder a esta información.', code: 400 } });
            const json = await response.json();
            dispatch({ type: 'REQUEST_PROVINCES', value: json.result.data });
        } catch (err) {
            if (!err.code && !err.status) err.status = 500;
            dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } })
        }
    }
}

export const getConsultTypes = (userName, passwd) => {
    return async (dispatch) => {
        try {
            const request = new Request(API_URL + "/v2/getConsultTypes", {
                method: 'POST',
                body: JSON.stringify({
                    username: userName,
                    password: passwd,
                }),
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            });
            const response = await fetch(request);
            if (response.status === 500) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } });
            if (response.status === 400 || response.status === 404) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non se poideron obter os datos correctamente.', code: 400 } });
            if (response.status === 403 || response.status === 401) return dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Non ten permisos para acceder a esta información.', code: 400 } });
            const json = await response.json();
            dispatch({ type: 'REQUEST_CONSULT_TYPES', value: json.result.data });
        } catch (err) {
            if (!err.code && !err.status) err.status = 500;
            dispatch({ type: 'REQUEST_ERROR', value: { msg: 'Produciuse un error interno no servidor. Non se poden obter os datos.', code: 500 } })
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/mainActions.js